export const authStatusForDisablingTriggerRpa = [
  "not_to_work_fedora",
  "not_to_work_stat",
  "worked_by_onsite",
  "not_available",
];

export const authStatusForDisablingMarkAsComplete = ["not_available"];
